import { useState } from 'react'
import { supabase } from '../supabase'

export default function ChangePassword({ onNavigate }) {
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)
    setSuccess(false)

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('All fields are required.')
      return
    }

    if (newPassword.length < 6) {
      setError('New password must be at least 6 characters.')
      return
    }

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match.')
      return
    }

    if (currentPassword === newPassword) {
      setError('New password must be different from current password.')
      return
    }

    setLoading(true)

    // First re-authenticate by signing in with current credentials
    const { error: signInError } = await supabase.auth.signInWithPassword({
      email: (await supabase.auth.getSession()).data.session.user.email,
      password: currentPassword,
    })

    if (signInError) {
      setLoading(false)
      setError('Current password is incorrect.')
      return
    }

    // Update password
    const { error: updateError } = await supabase.auth.updateUser({
      password: newPassword,
    })

    setLoading(false)

    if (updateError) {
      setError(updateError.message)
      return
    }

    setSuccess(true)
    setCurrentPassword('')
    setNewPassword('')
    setConfirmPassword('')
  }

  return (
    <div style={{ padding: '32px 40px', maxWidth: '520px' }}>
      <div style={{ marginBottom: '32px' }}>
        <span style={{ fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--green)', marginBottom: '4px', display: 'block' }}>Account</span>
        <h1 style={{ fontSize: '1.75rem', fontWeight: 700, color: 'var(--charcoal)', margin: 0 }}>Change Password</h1>
        <p style={{ fontSize: '0.875rem', color: 'var(--slate)', marginTop: '6px' }}>
          Update your account password. You'll need to enter your current password to confirm.
        </p>
      </div>

      {success && (
        <div style={{ padding: '14px 18px', background: '#e8f5e9', border: '1px solid #a5d6a7', borderRadius: '6px', color: '#2e7d32', fontSize: '0.875rem', fontWeight: 600, marginBottom: '20px' }}>
          ✓ Password updated successfully.
        </div>
      )}

      {error && (
        <div style={{ padding: '14px 18px', background: '#ffebee', border: '1px solid #ef9a9a', borderRadius: '6px', color: '#c62828', fontSize: '0.875rem', fontWeight: 600, marginBottom: '20px' }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', fontSize: '0.8125rem', fontWeight: 600, color: 'var(--charcoal)', marginBottom: '6px' }}>
            Current Password
          </label>
          <input
            type="password"
            value={currentPassword}
            onChange={e => setCurrentPassword(e.target.value)}
            style={{ width: '100%', padding: '10px 14px', fontSize: '0.9375rem', border: '1px solid var(--green-light)', borderRadius: '6px', outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }}
            placeholder="Enter current password"
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', fontSize: '0.8125rem', fontWeight: 600, color: 'var(--charcoal)', marginBottom: '6px' }}>
            New Password
          </label>
          <input
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            style={{ width: '100%', padding: '10px 14px', fontSize: '0.9375rem', border: '1px solid var(--green-light)', borderRadius: '6px', outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }}
            placeholder="Enter new password (min 6 characters)"
          />
        </div>

        <div style={{ marginBottom: '28px' }}>
          <label style={{ display: 'block', fontSize: '0.8125rem', fontWeight: 600, color: 'var(--charcoal)', marginBottom: '6px' }}>
            Confirm New Password
          </label>
          <input
            type="password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            style={{ width: '100%', padding: '10px 14px', fontSize: '0.9375rem', border: '1px solid var(--green-light)', borderRadius: '6px', outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }}
            placeholder="Re-enter new password"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{ padding: '12px 28px', fontSize: '0.9375rem', fontWeight: 700, background: loading ? 'var(--slate)' : 'var(--green)', color: 'var(--white)', border: 'none', borderRadius: '6px', cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}
        >
          {loading ? 'Updating...' : 'Update Password'}
        </button>
      </form>
    </div>
  )
}
